import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './bookingMsisdn.json';

const checkBookingMsisdn = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['bookingMsisdnController/checkBookingMsisdn'].success.default)));
};

export const handlers = [
  rest.post(getApiEndpoint('bookingMsisdnController/checkBookingMsisdn'), withScenario(withAuthCheck(checkBookingMsisdn))),
];


